<template>
  <div class="u-wrapper-panel">
    <div>
      <template v-for="(image, index) in images">
        <img
          :src="indexToLoad >= index ? image.resized : ''"
          @load="onImageLoad(index)"
          class="u-wrapper-panel u-fit-cover js-image-scroll"
        >
      </template>
    </div>

    <img v-if="fullImageIndex !== -1" :src="images[fullImageIndex].full" class="u-wrapper-panel u-fit-cover">
  </div>
</template>

<script>
import data from '@/assets/data'

import { VirtualScroll } from '@/utils/VirtualScroll'

import { clamp } from '@/utils/Maths'

const factorScroll = 30
const batchSize = 30

export default {
  data () {
    return {
      images: data.images,
      fullImageIndex: -1,
      indexLoaded: 0,
      totalBatchToLoad: Math.floor(data.images.length / batchSize),
      batchLoaded: 0,
      indexToLoad: 0,
      progress: 0
    }
  },

  created () {
    this.delta = 0
    this.imagesAvailable = 0
  },

  mounted () {
    this.scroll = new VirtualScroll()
    this.scroll.onSmoothScroll(this.onScroll)

    this.imagesEl = this.$el.querySelectorAll('.js-image-scroll')
  },

  beforeUnmount () {
    clearTimeout(this.timeout)
  },

  methods: {
    onScroll ({ progress, delta }) {
      this.delta += delta
    },
    onUpdate () {
      if (Math.abs(this.delta) > factorScroll) {
        this.progress += this.delta > 0 ? -1 : +1
        // - this.indexToLoad is to prevent seeing loading batch
        this.progress = clamp(this.progress, 0, this.imagesAvailable)
        this.delta = 0
        this.fullImageIndex = -1

        this.imagesEl[this.progress].style.opacity = 1
        if (this.progress !== 0) {
          this.imagesEl[this.progress-1].style.opacity = 0
        }
        if (this.progress < this.indexLoaded - 1) {
          this.imagesEl[this.progress+1].style.opacity = 0
        }
      }
      else {
        this.fullImageIndex = this.progress
      }
    },
    onImageLoad (index) {
      this.indexLoaded++
      this.batchLoaded = Math.floor(this.indexLoaded / batchSize)
      this.imagesAvailable = this.batchLoaded === this.totalBatchToLoad ? this.indexLoaded : this.batchLoaded * batchSize
      this.indexToLoad = clamp(batchSize, this.imagesAvailable + batchSize, this.images.length - 1)
    }
  }
}
</script>

<style lang="stylus">
.js-image-scroll
  opacity 0
</style>